var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43604 15.3672C8.32178 15.3672 8.21704 15.3481 8.12183 15.3101C8.02661 15.272 7.94092 15.2148 7.86475 15.1387C7.78857 15.0625 7.73145 14.9768 7.69336 14.8816C7.65527 14.7864 7.63623 14.6816 7.63623 14.5674C7.63623 14.4531 7.65527 14.3484 7.69336 14.2532C7.73145 14.158 7.78857 14.0723 7.86475 13.9961L12.0923 9.74951L7.86475 5.50293C7.80127 5.43945 7.75366 5.36011 7.72192 5.26489C7.69019 5.16968 7.67432 5.07764 7.67432 4.98877C7.67432 4.76025 7.75366 4.56665 7.91235 4.40796C8.07104 4.24927 8.2583 4.16992 8.47412 4.16992C8.57568 4.16992 8.67407 4.18579 8.76929 4.21753C8.8645 4.24927 8.94385 4.29688 9.00732 4.36035L13.8062 9.17822C13.8823 9.2417 13.9426 9.32422 13.9871 9.42578C14.0315 9.52734 14.0537 9.63525 14.0537 9.74951C14.0537 9.86377 14.0315 9.96851 13.9871 10.0637C13.9426 10.1589 13.8823 10.2446 13.8062 10.3208L8.98828 15.1387C8.9248 15.2021 8.84546 15.2561 8.75024 15.3005C8.65503 15.345 8.55029 15.3672 8.43604 15.3672Z",
    fill: "#252F4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic-next.39477c4b36ea0c77a024c20572cd1428.svg";
export { ForwardRef as ReactComponent };